import i18n from '@/i18n';
import api from '@/api';
import { localeChanged } from 'vee-validate';

import {
    FETCH_LOCALE,
    SWITCH_LOCALE
} from '../actions/i18n';

const updateLocale = locale => {
    i18n.locale = locale;
    localeChanged();
};

const actions = {
    async [FETCH_LOCALE](context) {
        let response = await api.get(`/app/locale/${i18n.locale}`);

        if (response && response.data)
            updateLocale(response.data);
    },

    async [SWITCH_LOCALE](context, locale) {
        updateLocale(locale);

        await api.post(`/app/locale/${locale}`);
    }
};

export default {
    namespaced: true,
    actions
};

